import styles from '@components/components/CmsComponents/components/CmsBlogPosts/CmsBlogPosts.module.scss';
import { Button, BlogCard, Link, Pill } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const CmsBlogPosts = ({
  blogCard: BlogCardElement = BlogCard,
  categories,
  items,
  headingLevel,
  isGhost = true,
  link,
}) => (
  <>
    {categories?.length > 0 && (
      <ul aria-label="Blog Kategorien" className={styles.categoriesList}>
        {categories?.map(({ link, name }) => (
          <li key={link}>
            <Pill render={<Link to={link} />}>{name}</Pill>
          </li>
        ))}
      </ul>
    )}
    <ul className={styles.container}>
      {items?.map(item => (
        <li className={styles.blogCardListItem} key={item.title}>
          <BlogCardElement {...item} headingLevel={headingLevel} />
        </li>
      ))}
    </ul>
    {!!link?.url && !!link?.title && (
      <div className={styles.buttonContainer}>
        <Button
          render={<Link target={link?.target || '_self'} to={link.url} />}
          theme={isGhost ? 'ghost' : 'primary'}
          variant="outline"
        >
          {link.title}
        </Button>
      </div>
    )}
  </>
);

CmsBlogPosts.propTypes = {
  blogCard: PropTypes.elementType,
  categories: PropTypes.arrayOf(
    PropTypes.shape({ link: PropTypes.string, name: PropTypes.string }),
  ),
  headingLevel: PropTypes.number,
  isGhost: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default CmsBlogPosts;
